import { createContext, useContext } from 'react';

/**
 * What the Settings shell has loaded once for every page, so the search can
 * show current values and the Overview and Privacy & monitoring can read
 * them without each fetching its own copy:
 *
 *   me         GET /auth/me
 *   rules      GET /app-settings (null until loaded)
 *   features   GET /features (null until loaded; { failed } if it could not)
 *   reloadRules, reloadFeatures   call after saving something, so the
 *              search and the Overview agree with the server at once
 *
 * Outside the shell (nothing should be, but a component must not crash for
 * it) every field is empty and the reloads do nothing.
 */
export const SettingsContext = createContext({
  me: null, rules: null, features: null,
  reloadRules: () => {}, reloadFeatures: () => {}
});

export const useSettings = () => useContext(SettingsContext);
